import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/MultiLineText.css";
import "../styles/SmartInput.css";
import "../styles/SmartInputNoAnimation.css";
import { createKey } from "../utils/KeysUtil";

class SmartInput extends React.Component {
  inputID = 0;
  constructor(props) {
    super(props);
    if (this.props.id === undefined) {
      this.inputID = createKey();
    } else {
      this.inputID = this.props.id;
    }
    this.focusMethod = this.focusMethod.bind(this);

    // Adicionando evento passivo de scroll para melhorar a performance
    this.addPassiveEventListeners = this.addPassiveEventListeners.bind(this);
    this.removePassiveEventListeners = this.removePassiveEventListeners.bind(this);
  };

  componentDidMount() {
    this.addPassiveEventListeners();
  }

  componentWillUnmount() {
    this.removePassiveEventListeners();
  }

  // Eventos passivos para melhor performance
  addPassiveEventListeners() {
    if (this.inputID) {
      const element = document.getElementById(this.inputID);
      if (element) {
        element.addEventListener('scroll', this.handlePassiveEvent, { passive: true });
        element.addEventListener('touchstart', this.handlePassiveEvent, { passive: true });
        element.addEventListener('touchmove', this.handlePassiveEvent, { passive: true });
        element.addEventListener('wheel', this.handlePassiveEvent, { passive: true });
      }
    }
  }

  removePassiveEventListeners() {
    if (this.inputID) {
      const element = document.getElementById(this.inputID);
      if (element) {
        element.removeEventListener('scroll', this.handlePassiveEvent);
        element.removeEventListener('touchstart', this.handlePassiveEvent);
        element.removeEventListener('touchmove', this.handlePassiveEvent);
        element.removeEventListener('wheel', this.handlePassiveEvent);
      }
    }
  }

  handlePassiveEvent = () => {
    // Não precisa fazer nada, só precisa existir para ser passivo
  };

  focusMethod = function getFocus() {
    let elementToFocus = document.getElementById(this.inputID);
    if (elementToFocus) elementToFocus.focus();
    if (this.props.onFocus) this.props.onFocus();
  };

  classNameWithRequiredDecoration = () => {
    if (this.props.noAnimation) {
      if (this.props.required && !this.props.disabled) {
        return "g-input-no-animation g-input-no-animation-required-border";
      } else {
        return "g-input-no-animation";
      }
    } else {
      if (this.props.required && !this.props.disabled) {
        return "g-input g-input-required-border";
      } else {
        return "g-input";
      }
    }
  };

  onChangeEventLocal = (event) => {
    if (this.props.onChange) {
      this.props.onChange(event);
    }
  };

  render() {
    // Garantir que o valor nunca seja undefined para evitar erro de input controlado/não-controlado
    const safeValue = this.props.value !== undefined ? this.props.value : "";

    if (this.props.type === "color") {
      return (
        <>
          <div className={this.classNameWithRequiredDecoration()}>
            <input
              id={this.inputID}
              ref={this.props.inputRef}
              value={safeValue}
              onBlur={this.props.onBlur}
              onChange={this.props.onChange}
              onFocus={this.props.onFocus}
              onKeyDown={this.props.onKeyDown}
              type={this.props.type}
              className={this.props.className}
              autoComplete={this.props.autoComplete}
              placeholder="&nbsp;"
              data-indx={this.props.indx}
              maxLength={this.props.maxLength}
              disabled={this.props.disabled ? this.props.disabled : false}
              title={this.props.title}
              style={{ minHeight: "94px", maxHeight: "94px" }}
            />
            {this.props.placeholder && (
              <label
                onClick={this.focusMethod}
                onFocus={this.focusMethod}
                title={this.props.title}
              >
                {this.props.placeholder} {this.props.required && !this.props.disabled ? "*" : ""}
              </label>
            )}
          </div>
        </>
      );
    } else if (this.props.type === "textarea") {
      return (
        <>
          <div className={this.classNameWithRequiredDecoration()}>
            <textarea
              id={this.inputID}
              ref={this.props.inputRef}
              value={safeValue}
              onBlur={this.props.onBlur}
              onChange={this.props.onChange}
              onFocus={this.props.onFocus}
              rows={this.props.rows}
              cols={this.props.cols}
              className={this.props.className}
              autoComplete={this.props.autoComplete}
              placeholder="&nbsp;"
              data-indx={this.props.indx}
              maxLength={this.props.maxLength}
              disabled={this.props.disabled ? this.props.disabled : false}
            />
            {this.props.placeholder && (
              <label onClick={this.focusMethod} onFocus={this.focusMethod}>
                {this.props.placeholder} {this.props.required && !this.props.disabled ? "*" : ""}
              </label>
            )}
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className={this.classNameWithRequiredDecoration()}>
            <input
              id={this.inputID}
              ref={this.props.inputRef}
              value={safeValue}
              onBlur={this.props.onBlur}
              onChange={this.props.onChange}
              onFocus={this.props.onFocus}
              onKeyDown={this.props.onKeyDown}
              type={this.props.type}
              className={this.props.className}
              autoComplete={this.props.autoComplete}
              placeholder="&nbsp;"
              data-indx={this.props.indx}
              maxLength={this.props.maxLength}
              disabled={this.props.disabled ? this.props.disabled : false}
              title={this.props.title}
              style={this.props.style}
            />
            {this.props.placeholder && (
              <label
                onClick={this.focusMethod}
                onFocus={this.focusMethod}
                title={this.props.title}
              >
                {this.props.placeholder} {this.props.required && !this.props.disabled ? "*" : ""}
              </label>
            )}
          </div>
        </>
      );
    }
  }
}

export default SmartInput;
